<template>
  <cube-toast :mask="true" :txt="msg" :time="2000"></cube-toast>
</template>
<script type="text/ecmascript-6">
  export default {
    data() {
      return {
        msg: '加载中...',
      };
    },
  };
</script>
<style lang="stylus" rel="stylesheet/stylus">
</style>




// WEBPACK FOOTER //
// src/components/loading/index.vue